import { Routes } from '@angular/router';

import { PageLeaveGuard } from '@safarilaw-webapp/shared/ui-kit/page-leave-guard';

export const routes: Routes = [
  {
    // Entry level to RMS
    path: '',
    providers: [
      //importProvidersFrom(FeatureRmsDataAccessModule),
    ],

    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        pathMatch: 'full',
        loadComponent: () => import('./home/components/home.component').then(a => a.HomeComponent),
        //  component: HomeComponent,
        canDeactivate: [PageLeaveGuard],
        data: {
          pageTitle: { title: 'SERVEPORT BY SAFARI®', useCompanyLogo: false, useCompanyLabel: false },
          operationName: 'Home'
        }
      },
      {
        path: 'profile',
        pathMatch: 'full',
        canDeactivate: [PageLeaveGuard],
        loadComponent: () => import('./profile/profile-edit/components/profile-edit/profile-edit.component').then(a => a.ProfileEditComponent),
        // component: ProfileEditComponent,
        data: {
          pageTitle: { title: 'My Profile', useCompanyLogo: false, useCompanyLabel: false },
          operationName: 'My Profile'
        }
      },

      {
        path: 'legal',
        pathMatch: 'full',
        loadComponent: () => import('./legal/components/legal-notice.component').then(a => a.LegalNoticeComponent),
        //    component: LegalNoticeComponent,
        canDeactivate: [PageLeaveGuard],
        data: {
          pageTitle: 'ServePort Terms of Service & Privacy',
          operationName: 'ServePort Terms of Service & Privacy'
        }
      },

      {
        path: 'portal',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./portal/components/portal.component').then(a => a.PortalComponent),
            // component: PortalComponent,
            canDeactivate: [PageLeaveGuard],
            data: {
              pageTitle: { title: 'Response Pickup Portal', useCompanyLogo: false, useCompanyLabel: false },
              operationName: 'Response'
            }
          },
          {
            path: 'confirm',
            pathMatch: 'full',
            loadComponent: () => import('./portal/components/confirm.component').then(a => a.ConfirmComponent),
            // component: ConfirmComponent,
            canDeactivate: [PageLeaveGuard],
            data: {
              pageTitle: 'Confirm',
              operationName: 'Confirm'
            }
          },
          {
            path: 'confirm/:id',
            pathMatch: 'full',
            loadComponent: () => import('./portal/components/confirm.component').then(a => a.ConfirmComponent),
            // component: ConfirmComponent,
            canDeactivate: [PageLeaveGuard],
            data: {
              pageTitle: { title: 'Confirm', useCompanyLogo: true, useCompanyLabel: false },
              operationName: 'Confirm'
            }
          },
          {
            path: ':id',
            pathMatch: 'full',
            loadComponent: () => import('./portal/components/portal.component').then(a => a.PortalComponent),
            // component: PortalComponent,
            canDeactivate: [PageLeaveGuard],
            data: {
              // This page can only be accessed in company context but there is no
              // company label - so we will just use the title and logo
              pageTitle: { title: 'Response Pickup Portal', useCompanyLogo: true, useCompanyLabel: false },
              operationName: 'Response',
              backgroundImage: '3'
            }
          }
        ]
      },
      {
        path: 'serve',
        children: [
          {
            // NOTE:  Keep this invalid spelling around in case
            path: 'acknowledgment/:id',
            pathMatch: 'full',
            loadComponent: () => import('./serve/components/serve-acknowledgment/serve-acknowledgment.component').then(a => a.ServeAcknowledgmentComponent),
            // component: ServeAcknowledgmentComponent,
            canDeactivate: [PageLeaveGuard],
            data: {
              // This page can only be accessed in company context so we are not
              // going to set any title and will fully depend on both logo and label
              pageTitle: { title: '', useCompanyLogo: true, useCompanyLabel: true },
              operationName: 'Serve Acknowledgment'
            }
          },
          {
            path: 'acknowledgment/:id',
            pathMatch: 'full',
            loadComponent: () => import('./serve/components/serve-acknowledgment/serve-acknowledgment.component').then(a => a.ServeAcknowledgmentComponent),
            // component: ServeAcknowledgmentComponent,
            canDeactivate: [PageLeaveGuard],
            data: {
              // This page can only be accessed in company context so we are not
              // going to set any title and will fully depend on both logo and label
              pageTitle: { title: '', useCompanyLogo: true, useCompanyLabel: true },
              operationName: 'Serve Acknowledgment'
            }
          },
          {
            // NOTE:  Keep this invalid spelling around in case
            path: 'batch-acknowledgment/:id',
            pathMatch: 'full',
            loadComponent: () => import('./serve/components/serve-acknowledgment/serve-acknowledgment-batch.component').then(a => a.ServeAcknowledgmentBatchComponent),
            // component: ServeAcknowledgmentBatchComponent),,
            canDeactivate: [PageLeaveGuard],
            data: {
              // This page can only be accessed in company context so we are not
              // going to set any title and will fully depend on both logo and label
              pageTitle: { title: '', useCompanyLogo: true, useCompanyLabel: true },
              operationName: 'Serve Acknowledgment'
            }
          },
          {
            path: 'batch-acknowledgment/:id',
            pathMatch: 'full',
            loadComponent: () => import('./serve/components/serve-acknowledgment/serve-acknowledgment-batch.component').then(a => a.ServeAcknowledgmentBatchComponent),
            // component: ServeAcknowledgmentBatchComponent),,
            canDeactivate: [PageLeaveGuard],
            data: {
              // This page can only be accessed in company context so we are not
              // going to set any title and will fully depend on both logo and label
              pageTitle: { title: '', useCompanyLogo: true, useCompanyLabel: true },
              operationName: 'Serve Acknowledgment'
            }
          },
          // IMPORTANT !!! THIS HAS TO BE THE LAST ENTRY IN ROUTING
          // IF IT GETS TO THIS POINT EVERYTHING AFTER /serve WILL BE CONSIDERED
          // A PORTAL ID AND IT WILL ATTEMPT TO LOAD IT FROM INTAKEPORTALS ENDPOINT
          {
            path: '**',
            pathMatch: 'full',
            loadComponent: () => import('./serve/components/serve.component').then(a => a.ServeComponent),
            // component: ServeDynamicComponent,
            canDeactivate: [PageLeaveGuard],
            // Must set runGuardsAndResolvers to 'always', otherwise PageLeaveGuard will not be called
            // when navigating to itself
            runGuardsAndResolvers: 'always',
            // This page can only be accessed in company context so we are not
            // going to set any title and will fully depend on both logo and label
            data: {
              pageTitle: { title: '', useCompanyLogo: true, useCompanyLabel: true },
              operationName: 'Serve'
            }
          }
        ]
      },
      {
        path: 'support',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./support/components/support.component').then(a => a.SupportComponent),
            // component: SupportComponent,
            canDeactivate: [PageLeaveGuard],
            data: {
              pageTitle: { title: '', useCompanyLogo: false, useCompanyLabel: false },
              operationName: 'Support'
            }
          },
          {
            path: 'about',
            pathMatch: 'full',
            loadComponent: () => import('./support/components/about.component').then(a => a.AboutComponent),
            // component: AboutComponent,
            canDeactivate: [PageLeaveGuard],
            data: {
              pageTitle: { title: '', useCompanyLogo: false, useCompanyLabel: false },
              operationName: 'About'
            }
          },
          {
            path: 'getting-started-serve',
            pathMatch: 'full',
            loadComponent: () => import('./support/components/gettingstarted.component').then(a => a.GettingStartedComponent),
            //component: GettingStartedComponent,
            canDeactivate: [PageLeaveGuard],
            data: {
              pageTitle: { title: '', useCompanyLogo: false, useCompanyLabel: false },
              operationName: 'Getting Started'
            }
          },
          {
            path: 'getting-started-responses',
            pathMatch: 'full',
            loadComponent: () => import('./support/components/gettingstarted.component').then(a => a.GettingStartedComponent),
            // component: GettingStartedComponent,
            canDeactivate: [PageLeaveGuard],
            data: {
              pageTitle: { title: '', useCompanyLogo: false, useCompanyLabel: false },
              operationName: 'Getting Started'
            }
          },
          {
            path: 'getting-started',
            pathMatch: 'full',
            loadComponent: () => import('./support/components/gettingstarted.component').then(a => a.GettingStartedComponent),
            // component: GettingStartedComponent,
            canDeactivate: [PageLeaveGuard],
            data: {
              pageTitle: { title: '', useCompanyLogo: false, useCompanyLabel: false },
              operationName: 'Getting Started'
            }
          }
        ]
      }
    ]
  }
];
